import React, { Component } from "react";

import { Card, CardBody, Col, Container, Row } from "reactstrap";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import MiniWidget from "../../../components/MiniWidget/index";
import ReactTableForm from "../../../components/Common/ReactTableForm";
import { getCurrentDay, getSelectedMonthAgo } from "../../../helpers/utils";
import DynamicFormToFilterSplit from "../../../components/forms/DynamicFormToFilterSplit";
import { Link } from "react-router-dom";
import ModifiedMetaTags from '../../../components/ModifiedMetaTags/index';

class DetailedByOffersReport extends Component {
  constructor(props) {
    super(props);

    this.state = {
      reports: null,
      data: {
        results: [
          {
            media_source: "Facebook",
            clicks: "1000",
            installs_post_click: "1000",
            CPI_post_click_plus_post_view: "1000",
            CPI_post_click: "1000",
            installs_post_view: "1000",
            shows: "1000",
            spend: "1000",
            payment: "1000",
            profit: "1",
            CTR: "1",
            CPC: "1",
            CPM: "1",
            CR: "1",
          },
          {
            media_source: "TikTok",
            clicks: "2000",
            installs_post_click: "2000",
            CPI_post_click_plus_post_view: "2000",
            CPI_post_click: "2000",
            installs_post_view: "2000",
            shows: "2000",
            spend: "2000",
            payment: "2000",
            profit: "1",
            CTR: "1",
            CPC: "1",
            CPM: "1",
            CR: "1",
          },
        ],
      },
      clients: [],
      columns: [
        {
          Header: "Media Source",
          // accessor: "media_source",
          accessor: "media_source",
          isSorted: true,
        },
        {
          Header: "Clicks",
          accessor: "clicks",
          isSorted: true,
        },
        {
          Header: "Installs post click",
          accessor: "installs_post_click",
          isSorted: true,
        },
        {
          Header: " CPI post click + post view",
          accessor: "CPI_post_click_plus_post_view",
          isSorted: true,
        },
        {
          Header: "CPI post click",
          accessor: "CPI_post_click",
          isSorted: true,
        },
        {
          Header: "Installs post view",
          accessor: "installs_post_view",
          isSorted: true,
        },
        {
          Header: "Shows",
          accessor: "shows",
          isSorted: true,
        },
        {
          Header: "Spend",
          accessor: "spend",
          isSorted: true,
        },
        {
          Header: "Payment",
          accessor: "payment",
          isSorted: true,
        },
        {
          Header: "Profit",
          accessor: "profit",
          isSorted: true,
        },
        {
          Header: "CTR",
          accessor: "CTR",
        },
        {
          Header: "CPC",
          accessor: "CPC",
        },
        {
          Header: "CPM",
          accessor: "CPM",
        },
        {
          Header: "CR",
          accessor: "CR",
        },
      ],
    };
  }

  componentDidMount() {}

  componentDidUpdate(prevProps, prevState, snapshot) {}

  onFiltersChange = (type, filter) => {};

  render() {
    return (
      <React.Fragment>
        <div className="page-content">
        <ModifiedMetaTags title="All Media Sources | Mobihunter" />

          <Container fluid>
            <Breadcrumbs
              title="Detailed by offers report"
              breadcrumbItem={"Detailed by offers report"}
              link="/detailed-by-offers-report"
            />

            <DynamicFormToFilterSplit
              onFiltersChange={this.onFiltersChange}
              filtersFields={[
                {
                  filterData: [],
                  plug: "Filter...",
                },
                {
                  filterData: [],
                  plug: "Filter...",
                },
                {
                  filterData: [],
                  plug: "Filter...",
                },
                {
                  filterData: [],
                  plug: "Filter...",
                },
                // {
                //   filterData: [],
                //   plug: "Filter...",
                // },
                // {
                //   filterData: [],
                //   plug: "Filter...",
                // },
                // {
                //   filterData: [],
                //   plug: "Filter...",
                // },
                // {
                //   filterData: [],
                //   plug: "Filter...",
                // },
                // {
                //   filterData: [],
                //   plug: "Filter...",
                // },
                // {
                //   filterData: [],
                //   plug: "Filter...",
                // },
                // {
                //   filterData: [],
                //   plug: "Filter...",
                // },
                // {
                //   filterData: [],
                //   plug: "Filter...",
                // },
                // {
                //   filterData: [],
                //   plug: "Filter...",
                // },
                // {
                //   filterData: [],
                //   plug: "Filter...",
                // },
                // {
                //   filterData: [],
                //   plug: "Filter...",
                // },
                // {
                //   filterData: [],
                //   plug: "Filter...",
                // },
                // {
                //   filterData: [],
                //   plug: "Filter...",
                // },
                // {
                //   filterData: [],
                //   plug: "Filter...",
                // },
                // {
                //   filterData: [],
                //   plug: "Filter...",
                // },
                // {
                //   filterData: [],
                //   plug: "Filter...",
                // },
              ]}
              selectedDate={[getSelectedMonthAgo(2), getCurrentDay()]}
            />

            {this.state.reports !== null && (
              <Col xl={12}>
                <Row>
                  <MiniWidget data={this.state.reports} />
                </Row>
              </Col>
            )}

            <Row>
              <Col className="col-12">
                <Card>
                  <CardBody>
                    <Row className="justify-content-between align-middle">
                      <Col xs={6}>
                        {/* HEADER */}
                        {/* <h5 className="mb-2">All media sources</h5> */}
                      </Col>
                    </Row>
                    <ReactTableForm
                      //loading={this.props.loading}
                      columns={this.state.columns}
                      data={this.state.data}
                      onTableChange={this.onTableChange}
                    />
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

DetailedByOffersReport.propTypes = {};

const mapStateToProps = state => ({});

export default connect(mapStateToProps, {})(DetailedByOffersReport);
